import { AppShell } from '@mantine/core';
import { createAddBonusModal } from 'features/add-bonus';
import { createBlockBonusModal } from 'features/block-bonus';
import { createDeleteBonusModal } from 'features/delete-bonus';
import { createEditBonusModal } from 'features/edit-bonus';
import { createBonusRegistry } from 'entities/bonus';
import { bonusesPageModel } from '../../model';
import cls from './bonuses-page.module.scss';

const BonusRegistry = createBonusRegistry(bonusesPageModel.bonusRegistryModel);

const AddBonusModal = createAddBonusModal(bonusesPageModel.addBonusModel);

const EditBonusModal = createEditBonusModal(bonusesPageModel.editBonusModel);

const BlockBonusModal = createBlockBonusModal(bonusesPageModel.blockBonusModel);

const UnblockBonusModal = createBlockBonusModal(bonusesPageModel.unblockBonusModel);

const DeleteBonusModal = createDeleteBonusModal(bonusesPageModel.deleteBonusModel);

export const BonusesPage = () => (
	<>
		<AppShell.Main className={cls.bonusesPage}>
			<BonusRegistry
				topBarActionSlot={<AddBonusModal.Button />}
				tableTdActionSlot={(bonus) => (
					<div className={cls.bonusesPageActions}>
						<EditBonusModal.ActionIcon modalData={bonus} />
						{bonus.isLocked ? (
							<UnblockBonusModal.ActionIcon modalData={bonus} />
						) : (
							<BlockBonusModal.ActionIcon modalData={bonus} />
						)}
						<DeleteBonusModal.ActionIcon modalData={bonus} />
					</div>
				)}
				emptyActionSlot={<AddBonusModal.Button />}
			/>
		</AppShell.Main>
		<AddBonusModal />
		<EditBonusModal />
		<BlockBonusModal />
		<UnblockBonusModal />
		<DeleteBonusModal />
	</>
);
